const Spinner: React.FC<{
  className?: string
  white?: boolean
}> = ({ white, className, ...props }) => (
  <svg
    viewBox='25 25 50 50'
    strokeWidth='4'
    {...{
      ...props,
      className:
        'spinner ' + 'spinner-' + (white ? 'white' : 'black') + ' ' + className
    }}
  >
    <circle cx='50' cy='50' r='20' fill='none' />
  </svg>
)

export default Spinner
